import {PathParamType} from '../routing.enums';
import type {PathParamDef} from '../routing.types';

function parsePathParam(paramValue: string, paramDef: PathParamDef): string | number {
  if (paramDef.type === PathParamType.Number) {
    const numValue = Number(paramValue);

    if (isNaN(numValue)) {
      throw new Error(`Invalid number value "${paramValue}" for path parameter "${paramDef.key}"`);
    }

    return numValue;
  }

  // PathParamType.String or default
  return paramValue;
}

export default parsePathParam;
